import React from 'react'
import { useCalculateTypography } from 'src/editor/shared/hooks/use-calculate-typography'
import { RemotePopupUi } from './remote-popup-ui'

interface RemotePopupProps {
  children?: React.ReactNode
}

export const RemotePopup = ({ children }: RemotePopupProps) => {
  const {
    calculatedFontSize,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateTypography()

  return (
    <RemotePopupUi
      fontFamily={calculatedFontFamily.desktop}
      fontSize={calculatedFontSize.desktop}
      mobileFontSize={calculatedFontSize.mobile}
    >
      {children}
    </RemotePopupUi>
  )
}
